<ng-template #OBJ_template_ref_remove>
  <div class="modal-body text-center gray-bg">
    <p>{{"remove_dialogue"|translate}}</p>
    <button type="button" class="btn btn-primary btn-circle" (click)="remove(STR_id)" title="{{'confirm'|translate}}"><i class="fa fa-check"></i></button>
    <button type="button" class="btn btn-warning btn-circle" (click)="hideModal('remove')" title="{{'abort'|translate}}"><i class="fa fa-remove"></i></button>
  </div>
</ng-template>

<ng-template #OBJ_template_ref>
  <div class="modal-body">
    <tig-form-component #OBJ_form [OBJ_item]="OBJ_item" [OBJ_config_fields]="OBJ_config_fields"></tig-form-component>
    <div class="text-center">
      <button class="btn btn-primary btn-circle" (click)="apply(OBJ_form)" title="{{'confirm'|translate}}"><i class="fa fa-check"></i></button>
      <button type="button" class="btn btn-warning btn-circle" (click)="hideModal()" title="{{'abort'|translate}}"><i class="fa fa-remove"></i></button>
      <button type="button" class="btn btn-danger btn-circle tig-a-t10-r10" (click)="openModal(OBJ_template_ref_remove, 'remove', STR_id)" title="{{'remove'|translate}}"
              *ngIf="OBJ_config_fields.allow_delete && STR_id !== null"><i class="fa fa-minus"></i></button>
    </div>
  </div>
</ng-template>

<ng-template tabHeading>
  <i class="fa tig-{{OBJ_config_fields.name.toLowerCase()}}"></i>
  <span class="tig-title">{{OBJ_helper_service.getLabelName(OBJ_config_fields)|translate}}</span>
</ng-template>
<h4 class="tig-title">{{OBJ_helper_service.getLabelName(OBJ_config_fields)|translate}}</h4>
<div class="ibox-tools">
  <button *ngIf="OBJ_config_fields?.allow_add" class="btn btn-primary btn-circle" (click)="createNew(OBJ_template_ref)" title="{{'new'|translate}}">
    <i class="fa fa-plus"></i></button>
</div>

<div class="table-responsive">
  <div id="tig-{{OBJ_config_fields.name.toLowerCase()}}-wrapper" class="dataTables_wrapper form-inline dt-bootstrap">
    <table id="tig-dt-element-{{OBJ_config_fields.name.toLowerCase()}}" datatable [dtOptions]="OBJ_dt_options" class="table table-striped table-bordered hover table-full-width"></table>
  </div>
</div>
